import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

export function useWikiSpacePages(spaceId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["wiki-spaces", spaceId ?? "--", "pages"],
		queryFn: async () => {
			if (!spaceId) throw new Error("No space ID provided");
			const response = await client.wiki.spaces[":spaceId"].pages.$get({
				param: { spaceId },
			});
			const data = await responseHandler(response);
			return data.wikiSpacePages;
		},
		enabled: !!spaceId,
	});

	/** Return */
	return { ...query, wikiSpacePages: query.data };
}
